import * as turf from "@turf/turf";

export default class {
  constructor(lat, lng) {
    this.lat = lat;
    this.lng = lng;
    this.latShort = this.shortenDecimal(`${lat}`);
    this.lngShort = this.shortenDecimal(`${lng}`);
  }

  isPresent() {
    return this.lat && this.lng;
  }

  isEmpty() {
    return !this.isPresent();
  }

  toArray() {
    return [this.lat, this.lng];
  }

  toObject() {
    return {
      lat: parseFloat(this.lat),
      lng: parseFloat(this.lng),
    };
  }

  toGeoJSON() {
    return turf.point([this.lng, this.lat]);
  }

  shortenDecimal(coord) {
    const decimalPoint = coord.indexOf(".");
    return decimalPoint === -1 ? coord : coord.substr(0, decimalPoint + 4);
  }

  // VDCI HQ
  static default() {
    let lat = localStorage.getItem("centerLat");
    let lng = localStorage.getItem("centerLng");

    if (lat && lng) {
      return new this(parseFloat(lat), parseFloat(lng));
    } else {
      return new this(34.7656875, -92.3081875);
    }
  }
}
